import { Ajax } from '@shared/Ajax';

export interface ISavedStateComment {
    id?: number;
    author: {
        username: string;
        id: number;
    };
    canvas: string;
    text: string;
    mentionedUsers?: string[];
    commentStateUrl?: string;
    sourcePage: 'MAP2D' | 'MAP3D';
    date: number;
    lat: number;
    lon: number;
    canvasVisible?: boolean;
    groupUuid?: string;
    roleUuid?: string;
}

export const SavedStateCommentsService = {
    fetch: (id, isLegacy = false): JQueryPromise<any> => {
        if (isLegacy) {
            return Ajax({
                url: 'visualization/screenshot_comments.json',
                data: { screenshotId: id },
            });
        } else {
            return Ajax({
                url: `/api/saved-view/${id}/comments`,
            }).then((r: { comments: ISavedStateComment[] }) => {
                r.comments.forEach(c => {
                    if (!c.sourcePage) c.sourcePage = 'MAP3D';
                });
                return r;
            });
        }
    },

    remove: (id, isLegacy = false): JQueryPromise<any> => {
        const request = {
            url: `/api/saved-view/comment?commentId=${id}`,
            method: 'delete',
        };

        const legacyRequest = {
            url: 'visualization/screenshot_comment/delete.json',
            method: 'post',
            data: { id },
        };

        return Ajax(isLegacy ? legacyRequest : request);
    },

    create: (ss: ISavedStateComment, isLegacy3dPage = false) => {
        const data: any = {
            pageStateId: ss.id,
            canvas: ss.canvas,
            text: ss.text,
            mentionedUsers: ss.mentionedUsers,
            commentStateUrl: ss.commentStateUrl,
            date: ss.date,
            sourcePage: ss.sourcePage,
            lat: ss.lat,
            lon: ss.lon,
            devicePixelRatio: window.devicePixelRatio,
            groupUuid: ss.groupUuid,
            roleUuid: ss.roleUuid,
        };

        if (isLegacy3dPage) {
            data.author = kuura.getUserId();
        }

        return Ajax({
            url: isLegacy3dPage ? 'visualization/screenshot_comment.json' : '/api/saved-view/comment',
            method: 'post',
            processData: isLegacy3dPage,
            data,
        });
    },
};
